export const changeStateNameReducer = (state = "AlQadarif", action) => {
    switch (action.type) {
      case "CHANGE_STATE_NAME":
        return action.payload.stateName;
      default:
        return state;
    }
  };
  